<template>
  <a-card :bordered="false" >
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addStory">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="title"
          :title="$t('TITLE')||'标题'"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="content"
          title="内容"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
<!--            <a-button type="link" @click="detailStory(record.id)">详情-->
<!--            </a-button>-->
            <a-button type="link" @click="editStory(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteStory(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="提示"
      v-model="form.visible">
      <website-story-edit
        v-if="form.visible"
        :story-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-story-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryStorys,
  _deleteStory,
} from '@/api/websiteStoryApi';
import WebsiteStoryEdit from './WebsiteStoryEdit.vue';

function searchUser() {
  this.table.pagination.page = 1;
  this.getStoryList();
}

async function getStoryList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryStorys({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function addStory() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editStory(storyId) {
  this.form.data.id = storyId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getStoryList();
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getStoryList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getStoryList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getStoryList();
}

async function deleteStory(storyId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteStory(storyId);
      this.$message.success('删除成功');
      await this.getStoryList();
    },
  });
}

// function detailStory(storyId) {
//   this.$router.push(`/story/${storyId}/positions`);
// }

export default {
  name: 'WebsiteStoryList',
  components: {
    WebsiteStoryEdit
  },

  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getStoryList,
    // detailStory,
    editStory,
    addStory,
    closeForm,
    handlePageChange,
    handleSizeChange,
    searchUser,
    handleTableChange,
    deleteStory,
  },
  created() {
    this.getStoryList();
  },
};
</script>

<style scoped>

</style>
